const PageMenuModel = {
    type: 'page',
    name: 'pageMenu',
    blocks: [
        {
            name: 'image', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'image', // || text || link || image || mixed (with children)
        },
        {
            name: 'title', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
        },
        {
            name: 'content',
            type: 'mixed',
            blocks: [
                {
                    name: 'title',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'text', // name or id; MUST be unique
                    type: 'html', // || text || link || image || mixed (with children)
                    max: 1, // max same items allowed
                },
                {
                    name: 'image',
                    type: 'image',
                    max: 1,
                },
            ],
        },
    ],
};

export default PageMenuModel;
